/**
 * Returns the value generated by fingerprint-rfg.js and returns 0 if the value
 * is not available. 0 is the default value when we are unable to get the value.
 * @returns string
 */
export const getRFGFingerprint = (): string => {
  return window.fp_rfg || '0';
};